var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_vm._v("\n      "+_vm._s(_vm.createdAt)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.note.postedByUser.fullName)+"\n    ")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_vm._v("\n      "+_vm._s(_vm.note.comment)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }